import type { CompanyStatus, userData } from '@/types/types';

export type DashboardVariant = 'pm' | 'employee' | 'samarbejde' | 'portfolio';

export const DASHBOARD_VARIANT_LABELS: Record<DashboardVariant, string> = {
  portfolio: 'Portefølje',
  pm: 'Projektleder',
  employee: 'Mit arbejde',
  samarbejde: 'Samarbejde',
};

export function getDefaultDashboardVariant(
  role: userData['role'] | undefined,
  companyStatus: CompanyStatus | undefined
): DashboardVariant {
  if (companyStatus === 'collab') return 'samarbejde';
  if (role === 'administrator') return 'portfolio';
  if (role === 'planner') return 'pm';
  return 'employee';
}

/**
 * Which variants a user is allowed to open. "Mit arbejde" is everyone's own
 * work, so it's always available. "pm"/"portfolio" require
 * planner/administrator respectively — administrators can also see the PM
 * view (role hierarchy), but not vice versa. Collab-status companies only
 * ever see "samarbejde", regardless of role.
 */
export function getAllowedDashboardVariants(
  role: userData['role'] | undefined,
  companyStatus: CompanyStatus | undefined
): DashboardVariant[] {
  if (companyStatus === 'collab') return ['samarbejde'];

  const variants: DashboardVariant[] = ['employee'];
  if (role === 'planner' || role === 'administrator') variants.push('pm');
  if (role === 'administrator') variants.push('portfolio');
  return variants;
}
